
export function isEmpty(value){
    return value == null || value === "" || (Array.isArray(value) && value.filter(p=>(!isEmpty(p))).length === 0) || (typeof value === "object" && Object.keys(value).length === 0)
}

export const validatePhone = (phone) => {
    const re = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
    return re.test(String(phone));
}

export const validateURL = (url) => {
    const re = new RegExp('^(https?:\\/\\/)?'+'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+'((\\d{1,3}\\.){3}\\d{1,3}))'+'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+'(\\?[;&amp;a-z\\d%_.~+=-]*)?'+'(\\#[-a-z\\d_]*)?$','i');
    return re.test(url);
}

export const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export const fileToBase64String = (file) => {
    return new Promise(resolve => {
        let baseURL = "";
    
        let reader = new FileReader();
    
        reader.readAsDataURL(file);
    
        reader.onload = () => {
          baseURL = reader.result;
          resolve(baseURL);
        };
      })
}
